export default class Maintenance {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        maintenanceRetrieve(id: ${id}) {
          id
          app
          dateTimeEnd
          dateTimeInit
          enabled
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.maintenanceRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        maintenanceList{
          results{
            id
            app
            dateTimeEnd
            dateTimeInit
            enabled
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.maintenanceList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/', {
        query: `mutation deleteMaintenance ($id: ID!){
          deleteMaintenance(id: $id){
            ok
          }
        }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.deleteMaintenance.ok;
  }

  static async create(axios, app, dateTimeEnd) {

    const response = await axios.post(
      '/graphql/',
      `mutation {
        createMaintenance(newMaintenance:{
          app: "${app}",
          dateTimeEnd: "${dateTimeEnd}",
        }){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createMaintenance.ok;
  }

  static async edit(axios, id, app, dateTimeEnd) {

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateMaintenance(newMaintenance:{
          id: "${id}",
          app: "${app}",
          dateTimeEnd: "${dateTimeEnd}",
        }){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateMaintenance.ok;
  }
}